/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition, // TableHeadingCell
} from 'griddle-react';
import { Link, browserHistory } from 'react-router';
import _ from 'lodash';

import classes from './Company.scss';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { Dialog, FlatButton } from 'material-ui';

// import {
//     TableHeadingCell
// } from 'griddle-react/src/components/TableHeadingCell';

import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';

const renderCell = data => (
  <Link to={`/company/${data.value._root.entries[1][1]}`}>
    {data.value._root.entries[0][1]}
  </Link>
);

const NoResults = () => (
  <div>
    <p className="text-center">
      <small>Keine Unternehmen eingetragen.</small>
    </p>
  </div>
);

// const TableHeading = ({ columnTitles, columnIds, TableHeadingCell, style, className }) => {
//     const headingCells = columnIds && columnTitles && columnTitles.map((t, i) => <TableHeadingCell
//       key={columnIds[i]}
//       title={t}
//       columnId={columnIds[i]}
//     />);
//
//     return (
//       <thead style={style} className={`className sticky-header`}>
//         <tr>
//           { headingCells }
//         </tr>
//       </thead>
//     );
// };

const prepareData = (dataArray, fetching) => {
  const returnData = {
    total: 0,
  };

  const newData = [];

  _.forOwn(dataArray, value => {
    // do something with key|value
    let type = [];
    const TYPES = {
      CUSTOMER: 'customer',
      SUPPLIER: 'supplier',
      FREELANCER: 'freelancer',
      INSTITUTION: 'institution',
    };
    if (
      typeof value.type !== 'undefined' &&
      value.type !== null &&
      value.type.length
    ) {
      if (_.indexOf(value.type, TYPES.CUSTOMER) !== -1) {
        type.push('Kunde');
      }
      if (_.indexOf(value.type, TYPES.SUPPLIER) !== -1) {
        type.push('Lieferant');
      }
      if (_.indexOf(value.type, TYPES.FREELANCER) !== -1) {
        type.push('Freelancer');
      }
      if (_.indexOf(value.type, TYPES.INSTITUTION) !== -1) {
        type.push('Institution');
      }
    }
    type = type.join(', ');

    if (value.is_my_company) {
      type = 'Ihr Unternehmen';
    }

    let address = '';
    if (
      value.addresses &&
      value.addresses.length &&
      value.addresses[0].street &&
      value.addresses[0].street.length
    ) {
      const ad = value.addresses[0];
      address = ad.street;
      if (ad.zip) {
        address += `, ${ad.zip}`;
      }
      if (ad.city) {
        address += `, ${ad.city}`;
      }
      if (ad.country) {
        address += `, ${ad.country}`;
      }
      // address = `${ad.street}, ${ad.zip} ${ad.city}, ${ad.country}`;
    }

    let vat = '';
    if (typeof value.meta.vat_number !== 'undefined') {
      vat = value.meta.vat_number.value;
    }

    if (value.deleted_at === null) {
      newData.push({
        id: value.id,
        link: {
          title: value.name,
          id: value.id,
        },
        type,
        address,
        vat,
        short: value.short_name,
      });

      returnData.total++;
    }
  });

  returnData.data = newData;
  return returnData;
};

class Company extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    this.props.fetchCompany();
  }

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderOverflow = data => (
    <IconMenu
      iconButtonElement={
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      }
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      <MenuItem
        primaryText="Bearbeiten"
        leftIcon={<EditIcon />}
        onTouchTap={e => this.props.setCompanyForm(data.value)}
      />
      <Divider />
      <MenuItem
        primaryText="Unternehmen löschen"
        leftIcon={<DeleteIcon className="svg-icon-primary svg-icon-warning" />}
        key="delCompany"
        className="menu-primary menu-warning"
        onClick={() => {
          this.setState({
            alert: (
              <Dialog
                actions={[
                  <FlatButton
                    label="Abbrechen"
                    primary
                    onTouchTap={this.handleAlertClose}
                  />,
                  <FlatButton
                    label="Löschen"
                    primary
                    onTouchTap={() => {
                      this.handleAlertClose();
                      this.props.deleteCompany(data.value);
                      browserHistory.push('/company');
                    }}
                  />,
                ]}
                modal={false}
                open
                onRequestClose={this.handleAlertClose}
              >
                Unternehmen wirklich löschen?
              </Dialog>
            ),
          });
        }}
      />
    </IconMenu>
  );

  renderLinksMobile = dataArray => {
    const links = [];

    _.forOwn(dataArray, value => {
      links.push(
        <div key={`mobile_link_${value.id}`}>
          <Link to={`/company/${value.id}`}>{value.name}</Link>
        </div>,
      );
    });

    return links;
  };

  render() {
    const props = this.props;
    const components = {
      NoResults, // TableHeading
    };
    const sortProperties = [
      {
        id: 'link',
        sortAscending: true,
      },
    ];

    if (window.innerWidth < 767) {
      return (
        <div className="wrapper">
          <div>
            <h2 className={`${classes.zenHeader} gutter`}>Unternehmen</h2>

            <div className="mobile-list">
              {this.renderLinksMobile(props.companies)}
            </div>
          </div>
        </div>
      );
    }

    const data = prepareData(props.companies, props.fetching);
    return (
      <div className="wrapper">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {data.total} Unternehmen
          </h2>

          <Griddle
            data={data.data}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
            sortProperties={sortProperties}
            sortMethod={caseInsensitiveSort}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="short"
                title="Kurzbezeichnung"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="link"
                title="Name"
                customComponent={renderCell}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="type"
                title="Typ"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="address"
                title="Anschrift"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="vat"
                title="USt-ID"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="id"
                title=" "
                width={70}
                sortable={false}
                cssClassName="OverFlowButton text-right"
                customComponent={this.renderOverflow}
              />
            </RowDefinition>
          </Griddle>

          {this.state.alert}
        </div>
      </div>
    );
  }
}
Company.propTypes = {
  fetchCompany: PropTypes.func.isRequired,
  setCompanyForm: PropTypes.func.isRequired,
  deleteCompany: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  company: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  companies: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
};
Company.defaultProps = {
  fetching: false,
  company: {},
  companies: {},
};
export default Company;



// WEBPACK FOOTER //
// ./src/routes/Company/components/Company.js